import { render } from "./SeriesItem.vue?vue&type=template&id=fc1c4ad4"
import script from "./SeriesItem.vue?vue&type=script&lang=js"
export * from "./SeriesItem.vue?vue&type=script&lang=js"

import "./SeriesItem.vue?vue&type=style&index=0&id=fc1c4ad4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__